// tslint:disable-next-line:no-submodule-imports
import { call, delay, put } from 'redux-saga/effects';
import { getImportKey, getImportProgress, uploadXML } from '../../repositories/DatabaseRepository';
import { takeEveryWithErrorHandling } from '../sagas';
import { importError, importSuccess, updateImportProgress } from './actionCreators';
import { ActionTypeNames, ImportXMLAction } from './actions';

function* watchImportXML() {
    yield takeEveryWithErrorHandling(ActionTypeNames.ImportXML, importXML, errorImportXML);
}

function* importXML(action: ImportXMLAction) {
    const formData = new FormData(document.getElementById('fileForm') as HTMLFormElement);
    const res = yield call(uploadXML, action.hostname, action.secure, action.workspaceId, formData);
    let progress = 0;
    while (progress < 1) {
        const p: { progress: number, state: string, error?: string } = yield call(getImportProgress);
        progress = p.progress;
        yield put(updateImportProgress(p.state, progress));
        if (p.error) {
            throw new Error(p.error);
        }
        yield delay(500);
    }
    const k: { key: string, hostname: string, secure: boolean } = yield call(getImportKey, action.hostname);
    yield put(importSuccess(k.key));
}

function* errorImportXML(err: Error) {
    yield put(importError(err));
}

export default [watchImportXML];